import { BLOCK_OUTPUT_FLUSH_INTERVAL_MS, BLOCK_OUTPUT_FLUSH_THRESHOLD } from '@consts';
import { useBlockOutputsCollector } from '@hooks/useBlockOutputsCollector';
import { useInMemoryStorage } from 'lib/hooks/useInMemoryStorage';
import { useBlockOutputsStore } from 'lib/stores/block_output_logs_store';
import { useEffect } from 'react';

export const BlockOutputsFlusher = () => {
  const { flush, retryPendingBlockOutputs } = useBlockOutputsCollector();
  const blockOutputsCount = useBlockOutputsStore((state) => state.blockOutputs.length);
  const userId = useInMemoryStorage((state) => state.userId);

  useEffect(() => {
    if (!userId) return;
    retryPendingBlockOutputs();
  }, [userId, retryPendingBlockOutputs]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      void flush().catch(() => undefined);
    }, BLOCK_OUTPUT_FLUSH_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [flush]);

  useEffect(() => {
    if (blockOutputsCount >= BLOCK_OUTPUT_FLUSH_THRESHOLD) {
      void flush().catch(() => undefined);
    }
  }, [blockOutputsCount, flush]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        void flush().catch(() => undefined);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [flush]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      void flush().catch(() => undefined);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [flush]);

  return null;
};
